import React, { useState } from "react";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { useTranslation } from "react-i18next";
import { FtextField } from "../../../components/common/FtextField";
import { Form, Formik } from "formik";
import Loader from "../../../components/common/Loader";
import { resellerBandwidthBillCollected } from "../../../features/apiCallReseller";
import { useDispatch } from "react-redux";

const ResellerRechargeDialog = ({ show, setShow, invoice }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //----> Local State
  const [isLoading, setIsLoading] = useState(false);

  const handleResellerBandwidthBillSubmit = (formValues) => {
    const recharge = {
      ...formValues,
      invoice: invoice?._id,
      reseller: invoice?.reseller,
      ispOwner: invoice?.ispOwner,
    };
    resellerBandwidthBillCollected(dispatch, recharge, setIsLoading, setShow);
  };

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={true}
        size={"md"}
        header={invoice?.month + " " + t("month") + " " + t("invoice")}
      >
        <Formik
          initialValues={{
            amount: invoice?.dueAmount,
          }}
          //   validationSchema={validationSchema}
          onSubmit={(values) => {
            handleResellerBandwidthBillSubmit(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form>
              <div className="displayGrid mt-3">
                <FtextField
                  label={t("invoicePaidAmount")}
                  name="amount"
                  validation={true}
                />
              </div>

              <div className="displayGrid1 float-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={isLoading}
                  onClick={() => setShow(false)}
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  className="btn btn-success customBtn"
                  disabled={isLoading}
                >
                  {isLoading ? <Loader /> : t("submit")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default ResellerRechargeDialog;
